import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import { SERVICES } from "@/lib/data";
import SectionHeading from "@/components/site/SectionHeading";

export default function ServicesPage() {
  return (
    <div>
      <section className="py-16 lg:py-24 border-b border-slate-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-sm font-semibold tracking-[0.18em] uppercase text-[#081537] mb-3">Services</div>
          <h1 className="font-[Outfit] text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-[#0F172A] text-balance max-w-3xl">
            Complete relocation services for homes, offices & businesses.
          </h1>
          <p className="mt-5 text-lg text-slate-600 max-w-2xl">
            Whatever your move looks like, we have a specialised crew and the right equipment to make it stress-free.
          </p>
        </div>
      </section>

      <section className="py-16 lg:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map(({ Icon, title, desc, slug }) => (
            <div key={slug} data-testid={`services-card-${slug}`} className="group bg-white border border-slate-200 rounded-2xl p-7 hover:shadow-xl hover:shadow-blue-900/5 hover:border-[#081537]/30 transition-all">
              <div className="w-14 h-14 rounded-xl bg-slate-100 text-[#081537] grid place-items-center mb-5 group-hover:bg-[#081537] group-hover:text-white transition-colors">
                <Icon className="w-7 h-7" strokeWidth={1.75} />
              </div>
              <h3 className="font-[Outfit] text-xl font-semibold text-[#0F172A]">{title}</h3>
              <p className="mt-2 text-slate-600 text-sm leading-relaxed">{desc}</p>
              <ul className="mt-4 space-y-1.5">
                {["Free site survey", "Quality packing materials", "Trained labour", "Insurance included"].map((p) => (
                  <li key={p} className="flex items-center gap-2 text-xs text-slate-600">
                    <CheckCircle2 className="w-3.5 h-3.5 text-green-500" /> {p}
                  </li>
                ))}
              </ul>
              <Link to="/quote" className="mt-6 inline-flex items-center gap-1 text-sm font-semibold text-[#081537] group-hover:text-[#081537] transition-colors">
                Get a quote <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-1 transition-transform" />
              </Link>
            </div>
          ))}
        </div>
      </section>

      <section className="py-16 bg-[#0F172A]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <SectionHeading overline="Ready when you are" title="Tell us about your move." align="center" />
          <div className="mt-8">
            <Link to="/quote" className="inline-flex items-center gap-2 bg-[#081537] hover:bg-[#0F2152] text-white rounded-full px-8 py-4 font-semibold transition" data-testid="services-quote-btn">
              Request a Private Consultation <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
